<template>
    <div>
        <div class="helpdesk-card">
            <div class="helpdesk-left">
                <ion-icon name="headset-outline" class="helpdesk-icon"></ion-icon>
                <span class="helpdesk-title">Help Desk</span>
            </div>
            <div class="helpdesk-actions">
                <a href="javascript:void(0)" class="helpdesk-btn call" title="Call" @click="onCall">
                    <ion-icon name="call-outline"></ion-icon>
                </a>
                <a href="javascript:void(0)" class="helpdesk-btn wa" title="WhatsApp" @click="onWhatsApp">
                    <ion-icon name="logo-whatsapp"></ion-icon>
                </a>
            </div>
        </div>

        <!-- Chooser sheet (shown when there is more than one number) -->
        <div class="modal fade action-sheet" :id="modalId" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Help Desk</h5>
                    </div>
                    <div class="modal-body">
                        <div class="action-sheet-content">
                            <div v-for="(n, i) in contacts" :key="i" class="hd-row">
                                <div class="hd-info">
                                    <div class="hd-name">{{ n.label || ('Help Desk ' + (i + 1)) }}</div>
                                    <div class="hd-num">+{{ n.number }}</div>
                                </div>
                                <div class="hd-acts">
                                    <a href="javascript:void(0)" class="helpdesk-btn call" title="Call" @click="dial(n.number)">
                                        <ion-icon name="call-outline"></ion-icon>
                                    </a>
                                    <a href="javascript:void(0)" class="helpdesk-btn wa" title="WhatsApp" @click="whatsapp(n.number)">
                                        <ion-icon name="logo-whatsapp"></ion-icon>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";

// ── Help Desk contacts — edit here. Add as many as needed. ──────────
// country code without "+", e.g. 919876543210
const HELP_DESK_CONTACTS = [
    { label: 'Help Desk 1', number: '919747880019' },
    { label: 'Help Desk 2', number: '919946773514' },
    { label: 'Help Desk 3', number: '919495018090' },
];

export default {
    name: "HelpDeskCard",
    props: {
        // optional override; falls back to the shared list above
        numbers: { type: Array, default: null },
        id: { type: String, default: 'helpDeskModal' },
    },
    computed: {
        contacts() {
            const list = (this.numbers && this.numbers.length) ? this.numbers : HELP_DESK_CONTACTS;
            return list.filter(n => n && n.number);
        },
        modalId() {
            return this.id;
        },
    },
    methods: {
        dial(num) {
            this.closeSheet();
            window.location.href = 'tel:+' + num;
        },
        whatsapp(num) {
            this.closeSheet();
            window.open('https://wa.me/' + num, '_blank');
        },
        onCall() {
            if (this.contacts.length <= 1) {
                if (this.contacts[0]) this.dial(this.contacts[0].number);
            } else {
                this.openSheet();
            }
        },
        onWhatsApp() {
            if (this.contacts.length <= 1) {
                if (this.contacts[0]) this.whatsapp(this.contacts[0].number);
            } else {
                this.openSheet();
            }
        },
        closeSheet() {
            try {
                // eslint-disable-next-line no-undef
                if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                    // eslint-disable-next-line no-undef
                    const inst = bootstrap.Modal.getInstance(document.getElementById(this.modalId));
                    if (inst) { inst.hide(); return; }
                }
            } catch (e) { /* fall through */ }
            $('#' + this.modalId).modal('hide');
        },
        openSheet() {
            try {
                // eslint-disable-next-line no-undef
                if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                    // eslint-disable-next-line no-undef
                    new bootstrap.Modal(document.getElementById(this.modalId)).show();
                    return;
                }
            } catch (e) { /* fall through */ }
            $('#' + this.modalId).modal('show');
        },
    },
};
</script>
<style scoped>
.helpdesk-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 12px;
    padding: 8px 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .04);
}
.helpdesk-left { display: flex; align-items: center; gap: 7px; min-width: 0; }
.helpdesk-icon { font-size: 20px; color: #1a418c; flex-shrink: 0; }
.helpdesk-title { font-size: 13px; font-weight: 800; color: #27173E; white-space: nowrap; }
.helpdesk-actions { display: flex; gap: 7px; }
.helpdesk-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: #fff;
    text-decoration: none;
}
.helpdesk-btn ion-icon { font-size: 18px; }
.helpdesk-btn.call { background: #1a418c; }
.helpdesk-btn.wa { background: #25D366; }

/* chooser rows */
.hd-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 4px;
    border-bottom: 1px solid #f1f3f7;
}
.hd-row:last-child { border-bottom: none; }
.hd-name { font-size: 14px; font-weight: 700; color: #27173E; }
.hd-num { font-size: 12px; color: #94a3b8; margin-top: 1px; }
.hd-acts { display: flex; gap: 8px; flex-shrink: 0; }
</style>
